var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-center",style:((_vm.ltr)?_vm.ltrStyle:{direction:'rtl'})},[_c('span',{domProps:{"textContent":_vm._s(_vm.value)}}),_c('span',{class:_vm.signClass},[_vm._v(_vm._s(_vm.sign))])])}
var staticRenderFns = []

export { render, staticRenderFns }